import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import SectionContainer from '../Container';

export const PageStyles = styled.div`
  background-color: ${({ themes }) =>
    themes === 'dark' ? 'transparent' : themeGet('colors.grey')};
`;

export const Section = styled.section`
  display: flex;
  align-items: center;
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  position: relative;
  height: 100%;
  padding: 2.5rem 0;
  background-color: ${themeGet('colors.grey')};

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 1.875rem 0;
  }
`;

export const Container = styled(SectionContainer)`
  text-align: center;
  align-items: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 0;
  }
`;

export const CategoryFaqs = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 3.75rem;
  border-radius: 10px;
  width: 100%;
  max-width: 63rem;

  background-color: ${({ themes }) =>
    themes === 'dark' ? themeGet('colors.body-bg') : themeGet('colors.white')};

  @media (max-width: ${themeGet('breakpoints.md')}) {
    max-width: 100%;
    width: 100%;
    padding: 2.5rem 1rem;
    border-radius: 0;
  }
`;

export const Heading = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  position: relative;

  h1 {
    font-size: 2.25rem;

    @media (max-width: ${themeGet('breakpoints.lg')}) {
      font-size: 1.75rem;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  position: relative;
  text-align: left;

  p {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;
